<template>
    <div class="service_box" id="printArea" style="page-break-before: always;">
        <h2 style="text-align: center;">
            {{ data.meetingtTitle }}会议记录
        </h2>
        <div class="middle_print">
            <div class="middleL_print">会议信息</div>
            <div class="middleR_print middleR1_print">
                <div>
                    <div class="middle_item">发起人： {{ data.principalName }}</div>
                    <div class="middle_item">会议时间：{{ data.meetingStateTime }}</div>
                    <div class="middle_item">会议主题：{{ data.meetingtTitle }}</div>
                    <div class="middle_item">会议地点：{{ data.meetingLocationName }}</div>
                    <div class="middle_item">签到开始时间：{{ data.meetingSignState }}</div>
                    <div class="middle_item">签到结束时间：{{ data.meetingSignEnd }}</div>
                    <div class="middle_item">邀请人员：{{ name }}</div>
                    <div class="middle_item">
                        <span>合计应到：{{ data.sysUserList ? data.sysUserList.length : null }}⼈</span>
                        其中
                        <span>准时签到{{ stateCount["1"] ? stateCount["1"] : 0 }}⼈</span>
                        <span v-show="stateCount[2] ? true : false">
                            迟到{{ stateCount["2"] }}⼈</span>
                        <span v-show="stateCount[3] ? true : false">
                            缺席{{ stateCount["3"] }}⼈</span>
                    </div>
                </div>
            </div>
        </div>
        <div class="service_main">
            <el-table :data="data2" style="width: 100%;">
                <el-table-column prop="createBy" label="记录人" align="center" min-width="180">
                </el-table-column>
                <el-table-column prop="name" label="记录内容" align="center" min-width="180">
                    <template slot-scope="scope">
                        <div v-html="scope.row.content"></div>
                    </template>
                </el-table-column>
            </el-table>
        </div>
    </div>
</template>

<script>
import dayjs from 'dayjs'
import config from "../../../../config";
export default {
    props: ["data2", "data", "stateCount", "name"],
    data() {
        return {
            tableData: [],
            list: [],
            classesDate: "",
            begin: "",
            end: "",
            customerName: "",
            loading: false,
            dayjsS: dayjs,
            printObject: {
                id: "printArea",
                popTitle: window.localStorage.getItem("customerName") + "服务报告",
                manualPageBreak: true,
            },
            pickerOptions: {
                disabledDate: (time) => {
                    let current_time = dayjs(new Date()).format('YYYY-MM-DD ') + "23:59:59";  //时间日期为：‘当前日期 23:59:59’
                    let t = new Date(current_time).getTime(); //‘当前日期 23:59:59’的时间戳
                    return time.getTime() > t;
                }
            },
        }
    },
    created() {
        this.classesDate = [
            dayjs().startOf("month").format("YYYY-MM-DD HH:mm:ss"),
            dayjs().format("YYYY-MM-DD HH:mm:ss")
        ]
        this.begin = dayjs().startOf("month").format("YYYY-MM-DD HH:mm:ss")
        this.end = dayjs().format("YYYY-MM-DD HH:mm:ss")
        this.load()
        this.customerName = window.localStorage.getItem("customerName")

    },

    methods: {
        async onExport() {
            let q = {
                begin: "",
                end: "",
            }
            q.begin = this.begin
            q.end = this.end
            this.loading = true
            let res = await $utils.api.load("/admin/system/htmlPdf/implCountEmail", q, "get")
            console.log(res);
            if (res.code == 200) {
                window.location.href =
                    config.API_HOST +
                    `/admin/common/download?fileName=${res.msg}`;
                this.loading = false
            }
        },
        //
        onClassSesDate(e) {
            this.begin = e[0]
            this.end = e[1]
            this.load()
        },
        async load() {
            let q = {
                begin: "",
                end: "",
                // pageSize: this.pageSize,
                // pageNum: this.pageNum,
            }
            q.begin = this.begin
            q.end = this.end
            this.loading = true
            let res = await $utils.api.load("/admin/statistics/deskCountEmail", q, "get")
            if (res.code == 200) {
                console.log(res);
                this.loading = false
                // this.total = res.data.length;
                // let list = res.data
                this.tableData = res.data
                // let obj = {
                //     name: "Total",
                //     allEvaluation: 0,
                //     allTotal: 0,
                //     avgTime: 0,
                //     consumableWorkTotal: 0,
                //     facilityTotal: 0,
                //     patrolWorkTotal: 0,
                //     ranking: 0,
                //     workTotal: 0
                // }
                // list.forEach(item => {
                //     obj.allEvaluation = (item.allEvaluation ? item.allEvaluation : 10) + obj.allEvaluation
                //     obj.allTotal = (item.allTotal ? item.allTotal : 0) + obj.allTotal
                //     obj.avgTime = (item.avgTime ? item.avgTime : 0) + obj.avgTime
                //     obj.consumableWorkTotal = (item.consumableWorkTotal ? item.consumableWorkTotal : 0) + obj.consumableWorkTotal
                //     obj.facilityTotal = (item.facilityTotal ? item.facilityTotal : 0) + obj.facilityTotal
                //     obj.patrolWorkTotal = (item.patrolWorkTotal ? item.patrolWorkTotal : 0) + obj.patrolWorkTotal
                //     obj.ranking = (item.ranking ? item.ranking : 0) + obj.ranking
                //     obj.workTotal = (item.workTotal ? item.workTotal : 0) + obj.workTotal
                //     obj.patrolWorkTotal = (item.patrolWorkTotal ? item.patrolWorkTotal : 0) + obj.patrolWorkTotal
                // })
                // obj.avgTime = parseInt(obj.avgTime / list.length)
                // obj.allEvaluation = parseInt(obj.allEvaluation / list.length)
                // this.tableData.unshift(obj)
            }
        },
        indexMethod(index) {
            return index
        }
    }
}
</script>

<style lang="less" media="print">
.service_box {
    // min-height: calc(100vh - 100px);


    .service_title {
        width: 100%;
        font-size: 28px;
        text-align: center;
        font-weight: 800;
    }

    .service_nav {
        width: 100%;
        display: flex;
        justify-content: space-between;
        margin: 20px 0;

        .service_nav_date {
            display: flex;
            align-items: center;
            width: 50%;

            .service_nav_date_left {
                margin-right: 10px;
            }

            .el-date-editor .el-range-separator {
                width: 10%;
            }
        }

        .service_nav_date_str {
            display: none;
            font-size: 16px;
        }

        .service_nav_right {
            display: flex;
            width: 40%;
            justify-content: right;
            align-items: center;
            padding: 0 20px;

            .service_nav_right_print {
                font-size: 16px;
                margin-left: 20px;
                margin-right: 20px;
            }
        }
    }

    .el-table tr:nth-child(1) {
        background: #66d4ff;
        font-weight: 600;
    }

    .middle_item {
        margin: 5px 0;
    }
}



@page {
    size: auto;
    margin: 3mm;
}

@media print {
    html {
        background-color: #ffffff;
        height: auto !important;
        margin: 0px;
    }

    body {
        border: solid 1px #ffffff;
        margin: 10mm 15mm 10mm 15mm;
    }

    .noprint {
        display: none !important;
    }

    .service_nav_date_str {
        display: block !important;
    }

    #printArea {
        width: 100%;
        // height: 100vh !important;
        overflow: visible !important;
    }

    .service_main {
        width: 100%;
        text-align: center;
    }

    #printArea table {
        table-layout: auto !important;
    }

    #printArea .el-table tr:nth-child(1) {
        background: #66d4ff !important;
        font-weight: 600;
        -webkit-print-color-adjust: exact;
        color-adjust: exact;
    }

    // #printArea .el-table--enable-row-transition .el-table__body td.el-table__cell {
    //     background: #66d4ff !important;
    // }

    // #printArea .el-table {
    //     height: 100vh !important;
    // }

    #printArea .el-table__header-wrapper .el-table__header {
        width: 100% !important;
    }

    #printArea .el-table__body-wrapper .el-table__body {
        width: 100% !important;
    }

    #printArea #pagetable table {
        table-layout: fixed !important;
    }
}
</style>